/**
 * Vuex Store
 *
 * The {@link http://vuex.vuejs.org/en/index.html | store } of the application.
 */

import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import quiz from './modules/quiz';
import menu from './modules/menu';
import topic from './modules/topic';
import device from './modules/device';
import ad from './modules/ad';
import course from './modules/course';
import news from './modules/news';
import lesson from './modules/lesson';
import image from './modules/image';
import notification from './modules/notification';
import navbar from './modules/navbar';
import user from './modules/user';
import popup from './modules/popup';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    /**
     * Assign the modules to the store.
     */
    modules: {
        auth,
        quiz,
        menu,
        topic,
        device,
        ad,
        course,
        news,
        lesson,
        image,
        notification,
        navbar,
        user,
        popup,
    },

    /**
     * If strict mode should be enabled.
     */
    strict: debug,
});



// WEBPACK FOOTER //
// ./src/store/index.js